import React, { useContext } from 'react';
import ButtonBack from './images/Icon_Close.png';
import ItemImage from './images/AntFood.png';

function ItemsReceived({ onClose }) {

  return (
    <div className="popup-container">
      <div className="popup" id="itemsreceived">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} />
        </button>
        <div className="solar"></div>
        <h2>Items Received</h2>
        <div className="itemsreceived-container">
            <img src={ItemImage} />
            <h2>14</h2>
      </div>
    </div>
    </div>
  );
}

export default ItemsReceived;